import { Box, BoxProps } from '@air/zephyr';

export interface UnderlineProps extends BoxProps<'u'> {}

export const Underline = ({ tx, ...restOfProps }: UnderlineProps) => {
  return <Box as="u" {...restOfProps} tx={{ textDecoration: 'underline', ...tx }} />;
};

const Squiggly = () => {
  return (
    <svg
      height="5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ zIndex: -1, position: 'absolute', bottom: 0, width: '100%', left: 0 }}
    >
      <pattern id="squiggly" x="0" y="0" width="78" height="5" patternUnits="userSpaceOnUse">
        <path
          d="M0 1.67188C10.5043 1.67188 10.5043 3.03799 19.8895 3.03799C29.2747 3.03799 29.2747 1.67188 38.6622 1.67188C48.0496 1.67188 48.0496 3.03799 57.4348 3.03799C66.82 3.03799 66.8223 1.67188 78.2075 1.67188"
          stroke="#33DBDB"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </pattern>
      <rect x="0" y="0" width="100%" height="100%" fill="url(#squiggly)"></rect>
    </svg>
  );
};

export const SquigglyUnderline = ({ children, tx, ...restOfProps }: UnderlineProps) => {
  return (
    <Box as="u" {...restOfProps} tx={{ zIndex: 1, position: 'relative', textDecoration: 'none', ...tx }}>
      {children}
      <Squiggly />
    </Box>
  );
};
